import * as React from "react";
import * as ReactDOM from "react-dom";

import App from "./Application";

import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);

if (process.env.REACT_APP_ENV === "dev") {
    console.log("In dev mode, starting service worker");
    registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.tsx